import React, { useEffect } from 'react';
import { ScreenNamesEnum } from '@/constants';
import { useAppRouter } from '@/hooks/use.app.router';

interface Props {
  to: ScreenNamesEnum;
  type: 'navigate' | 'reset';
}
export function Redirect({ to, type }: Props) {
  const { resetStackTo, navigateTo } = useAppRouter();
  useEffect(() => {
    if (type === 'navigate') {
      navigateTo(to);
    } else {
      resetStackTo(to);
    }
  }, [navigateTo, resetStackTo, to, type]);
  return <></>;
}
